import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import CustomButton from "../shared/CustomButton";
import { Typography } from "@mui/material";
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import blogsData from "../blogs";

const Myposts = () => {
  const navigate = useNavigate();
  const [posts] = useState([
    {
      title: "Post 1",
      topic: "Technology",
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque nisl eros, pulvinar facilisis justo mollis, auctor consequat urna.",
      featuredImage: "https://via.placeholder.com/150",
      likes_count: 12,
    },
    {
      title: "Post 2",
      topic: "Science",
      text: "Maecenas vehicula risus ut quam fringilla, et sollicitudin felis bibendum. Nulla vel purus vel sapien cursus pharetra.",
      featuredImage: "https://via.placeholder.com/150",
      likes_count: 24,
    },
    {
      title: "Post 3",
      topic: "Health",
      text: "Proin sit amet dapibus justo. Nulla facilisi. Phasellus at ex euismod, vehicula augue vel, dapibus metus.",
      featuredImage: "https://via.placeholder.com/150",
      likes_count: 18,
    },
  ]);

  const handleNavigation = (index) => {
      navigate(`/blogsPage/${index+1}`);
  };

  return (
    <>
      <div className="mb-[20px] min-w-[0px] text-white">
        <CustomButton>
        <Typography variant='h6' sx={{fontFamily:'Crimson Text, serif'}} >My Posts </Typography>
        </CustomButton>

        <div className="min-w-[0px] w-auto flex flex-col md:flex-row md:flex-wrap">
          {blogsData && blogsData.length > 0 ? (
            blogsData.map((blog, index) => (
              <div
                key={index}
                onClick={() => handleNavigation(index)}
                className="md:w-[48%] md:px-[30px] p-6 mt-4 mr-4 bg-gray-700 rounded-lg shadow-lg cursor-pointer transform transition-transform hover:scale-105"
              >
                <div className="flex content-space-between">
                  <h3 className="text-xl font-[500] mb-4 text-gray-500">{blog.title}</h3>
                </div>

                <div className="flex flex-col-reverse md:flex-row md:justify-between items-center mb-4">
                  <div className="md:max-w-[70%]">
                    <p className="text-base mr-2 line-clamp-5">
                      {blog.description}
                    </p>
                    {/* <div className="flex gap-5 my-[10px]">
                      <div className="flex">
                        <div>
                          <span className="text-white">
                            <FavoriteBorderIcon/>
                          </span>
                        </div>
                        <div className="pl-[5px]">
                          <span>{blog.likes_count}</span>
                        </div>
                      </div>
                    </div> */}
                  </div>
                  <img
                    src={blog.featuredImage}
                    alt="Placeholder"
                    className="my-[10px] w-32 h-32 rounded-md object-cover"
                  />
                </div>

<div className="flex flex-row flex-wrap">
                {
                blog.tags.map((value, index) => (
                <div key={index} className="bg-[#f2f2f2] p-2 mr-2 my-1 rounded-[25px] cursor-pointer text-black w-fit">
                {value}
              </div>
              ))}
 
 </div>
              </div>
          
            ))
          ) : (
            <div>No posts to show here</div>
          )}
        </div>
      </div>
    </>
  );
};

export default Myposts;
